import { Component, effect, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { NgIf } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ParamsConfig, paramsConfig } from '../../services/params/models/params.config';
import { ButtonComponent } from '../button/button.component';
import { ParamsService } from '../../services/params/params.service';

@Component({
    selector: 'l-filter',
    templateUrl: './filter.component.html',
    imports: [
        IconComponent,
        NgIf,
        ReactiveFormsModule,
        ButtonComponent
    ]
})
export class FilterComponent {

  constructor(
    protected readonly elementRef: ElementRef,
    protected readonly formBuilder: FormBuilder,
    protected readonly paramsService: ParamsService,
  ) {
    let group: { [key in keyof ParamsConfig]: FormControl } = Object
      .keys(paramsConfig)
      .reduce(
        (acc, key) => {
          const typedKey = key as keyof ParamsConfig;
          acc[typedKey] = new FormControl([]);

          return acc;
        }, {} as { [key in keyof ParamsConfig]: FormControl }
      );

    this.formGroup = this.formBuilder.group(group);

    effect(() => {
      const params = this.paramsService.params();

      this.formGroup.reset(params, { emitEvent: false });
      this.formGroup.patchValue(params, { emitEvent: false });
    })
  }

  @Input()
  protected isOpen: boolean = false;

  @Output()
  protected isOpenChange = new EventEmitter<boolean>();

  public formGroup: FormGroup;

  public open(): void {
    this.isOpen = true;
    this.isOpenChange.emit(this.isOpen);
  }

  protected close(): void {
    this.isOpen = false;
    this.isOpenChange.emit(this.isOpen);
  }

  protected async confirm(): Promise<void> {
    this.paramsService.params = {
      ...this.formGroup.getRawValue(),
    };

    this.close();
  }

  protected async clear(): Promise<void> {
    const formControls = this.formGroup.controls;
    const keys = this.getFormKeys();

    const emptyParams = keys.reduce((acc: { [key: string]: any }, key) => {
      if (formControls[key])
        acc[key] = null;

      return acc;
    }, {});

    this.paramsService.params = {
      ...emptyParams,
    };

    this.formGroup.patchValue({
      ...emptyParams,
    });

    this.close();
  }

  protected getFormKeys(): string[] {
    const declaredControlNames: string[] = [];
    const inputs = this.elementRef.nativeElement.querySelectorAll('[formControlName]');

    inputs.forEach((input: any) => {
      declaredControlNames.push(input.getAttribute('formControlName'));
    });

    return declaredControlNames;
  }

}
